//frontend/src/utils/ioc.ts
export type IOCResult = {
  emails: string[];
  domains: string[];
  phones: string[];
  crypto: string[];
};

export function extractIOCs(text: string): IOCResult {
  if (!text) {
    return { emails: [], domains: [], phones: [], crypto: [] };
  }

  const emails =
    text.match(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi) ?? [];

  const domains =
    text.match(
      /\b(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}\b/gi
    ) ?? [];

  const phones =
    text.match(
      /\b(?:\+?\d{1,3}[-.\s]?)?\(?\d{2,4}\)?[-.\s]?\d{3,4}[-.\s]?\d{4}\b/g
    ) ?? [];

  const crypto =
    text.match(/\b(?:bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}\b/g) ?? [];

  return {
    emails: Array.from(new Set(emails)),
    domains: Array.from(new Set(domains)),
    phones: Array.from(new Set(phones)),
    crypto: Array.from(new Set(crypto)),
  };
}
